<svg
  width="33"
  height="33"
  viewBox="0 0 33 33"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_2053_1453)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.1035 0.153772L27.3192 0.508781C25.8526 0.646363 25.1193 0.715155 24.9471 1.19296C24.7749 1.67077 25.2957 2.19157 26.3373 3.23316L27.4332 4.32909L27.2348 4.52753L27.233 4.52927L25.642 6.12026L25.6403 6.122L22.9923 8.77L22.9904 8.77191L21.3994 10.3629L21.3975 10.3648L6.13731 25.625H0.874756C0.391507 25.625 -0.000244141 26.0167 -0.000244141 26.5C-0.000244141 26.9832 0.391507 27.375 0.874756 27.375H4.38731L0.260367 31.5019C-0.0813413 31.8436 -0.0813413 32.3977 0.260367 32.7394C0.602076 33.0811 1.1561 33.0811 1.4978 32.7394L6.86219 27.375H12.1248C12.608 27.375 12.9998 26.9832 12.9998 26.5C12.9998 26.0167 12.608 25.625 12.1248 25.625H8.61219L22.6368 11.6003L24.2278 10.0093L26.8795 7.35769L28.4705 5.7667L28.6707 5.56653L29.7666 6.66246C30.8082 7.70405 31.329 8.22485 31.8068 8.05263C32.2846 7.88042 32.3534 7.14712 32.491 5.68053L32.846 1.89622C32.9295 1.00564 32.9713 0.560344 32.7053 0.294398C32.4394 0.0284522 31.9941 0.0702254 31.1035 0.153772Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_2053_1453">
      <rect
        width="33"
        height="33"
        fill="white"
        transform="translate(-0.000244141)"
      />
    </clipPath>
  </defs>
</svg>
